import type { ResourcePrice } from "../resource-price/resource-price";
import type { ManifestBookableOption } from "./manifest-bookable-option";
import type { QuantityPickerBookableOption } from "./quantity-picker-bookable-option";

type BookableOption = QuantityPickerBookableOption | ManifestBookableOption;
type BookableOptionType = BookableOption["_type"];

const hasResourcePrice = <T>(
    item:
        | (T & {
              resourcePrice?: ResourcePrice;
          })
        | undefined,
): item is T & { resourcePrice: ResourcePrice } => {
    if (typeof item === "undefined") return false;
    return typeof item.resourcePrice !== "undefined";
};

export { hasResourcePrice };
export type { BookableOption, BookableOptionType };
